import * as React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import "antd/dist/antd.css";
import { GlobalStyle } from "./css";

import Login from "./pages/login";

import zhCN from "antd/es/locale/zh_CN";
import { ConfigProvider } from "antd";
import MainLayout from "./comp/mainlayout";

const Index: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <HashRouter>
        <GlobalStyle />
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/group/*" element={<MainLayout />}></Route>
        </Routes>
      </HashRouter>
    </ConfigProvider>
  );
};

export default Index;
